// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `page-section .section {
  --sub-section-side-padding: max(var(--safe-area-left), 10vw);
  --sub-section-mid-padding: 5vw;
  --sub-section-top-padding: 10vh;
  --sub-section-height: inherit;
  display: flex;
  justify-content: center;
  align-items: stretch;
  overflow: hidden;
  position: relative;
}
page-section .section picture.bg {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: absolute;
  height: 100%;
  width: 100%;
}
page-section .section picture.bg img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
}
page-section .section light-image.bg {
  position: absolute;
  height: 100%;
  width: 100%;
}
page-section .section light-image.bg .image-container {
  padding-top: unset;
  height: inherit;
}
page-section .section light-image.bg .image-container picture {
  display: flex;
  justify-content: center;
  align-items: center;
  height: inherit;
}
page-section .section light-image.bg .image-container picture img {
  position: initial;
  top: initial;
  left: initial;
  width: initial;
  box-sizing: initial;
  min-height: 100%;
}
page-section .section .bg.dark, page-section .section .bg-image .image {
  background-color: var(--secondary-color);
}
page-section .section .bg.dark img, page-section .section .bg-image .image img {
  opacity: 0.2;
}
page-section .section.LARGE {
  min-height: 75vh;
  align-items: center;
}
page-section .section.FULL {
  min-height: calc(100vh - var(--header-height) - var(--safe-area-bottom));
  align-items: center;
}
page-section .section.parent {
  flex-direction: column;
}
page-section .section.parent > .sub-section:first-child {
  padding-bottom: 0;
}
page-section .section:has(.sub-section:only-child) {
  flex-direction: column;
}
page-section .section .sub-section {
  position: relative;
  height: var(--sub-section-height);
  flex: 50%;
  box-sizing: border-box;
}
page-section .section .sub-section img {
  align-self: center;
}
page-section .section .sub-section.large {
  --sub-section-side-padding: 12vw;
  --sub-section-mid-padding: 12vw;
}
page-section .section .sub-section.bg-image {
  min-height: inherit;
  align-self: stretch;
}
page-section .section .sub-section.bg-image picture.image {
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
page-section .section .sub-section.bg-image picture.image img {
  align-self: auto;
  object-fit: cover;
  width: 100%;
}
page-section .section .sub-section.bg-image .image-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: var(--sub-section-top-padding) var(--sub-section-mid-padding);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
page-section .section .sub-section.bg-image .image-overlay img {
  width: 100%;
  max-height: 40vh;
  object-fit: contain;
}
page-section .section .sub-section.image, page-section .section .sub-section.floating-element {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
page-section .section .sub-section.image img, page-section .section .sub-section.floating-element img {
  object-fit: cover;
  height: 100%;
  align-self: center;
}
page-section .section .sub-section.image motes-media, page-section .section .sub-section.floating-element motes-media {
  width: 100%;
}
page-section .section .sub-section.image motes-media #media-container, page-section .section .sub-section.floating-element motes-media #media-container {
  height: 100%;
}
page-section .section .sub-section.image motes-media #media-container .image-container, page-section .section .sub-section.floating-element motes-media #media-container .image-container {
  height: 100%;
}
page-section .section .sub-section.floating-element {
  align-items: center;
}
page-section .section .sub-section.floating-element img, page-section .section .sub-section.floating-element video {
  width: 100%;
  height: auto;
}
page-section .section .sub-section.padded-left, page-section .section .sub-section.padded-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
page-section .section .sub-section.padded-left img, page-section .section .sub-section.padded-right img {
  object-fit: contain;
  max-height: 100%;
  max-width: 100%;
}
page-section .section .sub-section.padded-center {
  padding: var(--sub-section-top-padding) var(--sub-section-side-padding);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
page-section .section .sub-section.center-text, page-section .section .sub-section.dynamic-text {
  align-items: center;
  justify-content: center;
  text-align: center;
}
page-section .section .sub-section.center-text h1::after, page-section .section .sub-section.center-text h2::after, page-section .section .sub-section.dynamic-text h1::after, page-section .section .sub-section.dynamic-text h2::after {
  margin: 0 auto;
}
page-section .section .sub-section.order-one {
  order: 0;
}
page-section .section .sub-section.order-two {
  order: 1;
}
page-section .section .sub-section.padded-left {
  order: 0;
  padding: var(--sub-section-top-padding) var(--sub-section-mid-padding) var(--sub-section-top-padding) var(--sub-section-side-padding);
}
page-section .section .sub-section.padded-right {
  order: 1;
  padding: var(--sub-section-top-padding) var(--sub-section-side-padding) var(--sub-section-top-padding) var(--sub-section-side-padding);
}
page-section .section .sub-section.image-bg {
  min-height: inherit;
  padding: 0;
  padding: var(--sub-section-top-padding) var(--sub-section-side-padding);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
page-section .section p, page-section .section expandable-paragraphs .title {
  max-width: 800px;
}
page-section .section.BLACK {
  background-color: var(--motes-light-black);
}
page-section .section.BLACK a > p, page-section .section.BLACK p a {
  color: var(--primary-color);
}
page-section .section.WHITE a > p, page-section .section.WHITE p a {
  color: var(--tertiary-color);
}
page-section .section.YELLOW {
  background: transparent linear-gradient(180deg, #FFDC8B 0%, #EFBE61 100%) 0% 0% no-repeat padding-box;
}
page-section .section.YELLOW h1::after, page-section .section.YELLOW h2::after {
  border-bottom-color: var(--secondary-color);
}
page-section .section.YELLOW h1, page-section .section.YELLOW h2, page-section .section.YELLOW h3, page-section .section.YELLOW p, page-section .section.YELLOW ol, page-section .section.YELLOW ul, page-section .section.YELLOW .icon, page-section .section.YELLOW a:hover {
  color: var(--secondary-color);
}
page-section .section.YELLOW a > p, page-section .section.YELLOW p a {
  color: var(--tertiary-color);
}
page-section .section.YELLOW .button-filled {
  background-color: var(--secondary-color);
  border-color: var(--secondary-color);
  color: var(--motes-white);
}
page-section .section.YELLOW .button-filled:hover, page-section .section.YELLOW .button-filled:active {
  border-color: var(--motes-darker-gray);
  background-color: var(--motes-darker-gray);
}
page-section .section.YELLOW .button-outline {
  border: solid 2px var(--secondary-color);
  background-color: transparent;
  color: var(--secondary-color);
}
page-section .section.YELLOW .button-outline:hover, page-section .section.YELLOW .button-outline:active {
  background-color: rgba(34, 34, 34, 0.15);
}
page-section .section .sub-section.trailer-container {
  cursor: pointer;
  position: relative;
}
page-section .section .sub-section.trailer-container .play-overlay {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 70px;
}
page-section .section .horizontal-wrap-list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
page-section .section .horizontal-wrap-list > * {
  width: 100%;
  height: 100%;
  margin: var(--motes-padding);
}
page-section .section .horizontal-wrap-list > :first-child:not(:only-child) {
  margin-left: 0;
}
page-section .section .horizontal-wrap-list > :last-child:not(:only-child) {
  margin-right: 0;
}
page-section .section .horizontal-wrap-list button {
  white-space: nowrap;
}
page-section .section .horizontal-wrap-list {
  margin-top: var(--sub-section-mid-padding);
}
page-section .section .horizontal-wrap-list * > img {
  width: 100%;
  height: 100%;
  max-height: 150px;
  object-fit: contain;
}
page-section .section .horizontal-pile-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
page-section .section .horizontal-pile-list > * {
  margin: 0 var(--motes-padding);
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: min(40%, 400px);
  min-width: 280px;
}
page-section .section .horizontal-pile-once-list {
  display: flex;
}
page-section .section .horizontal-pile-once-list > * {
  margin: var(--motes-padding);
}
page-section .section .scroll-container {
  overflow-x: scroll;
  overflow-y: hidden;
  width: 100vw;
  align-self: center;
}
page-section .section .scroll-container::-webkit-scrollbar {
  display: none;
}
page-section .section .scroll-container.short .inner-scroll-container {
  justify-content: center;
}
page-section .section .scroll-container.short .inner-scroll-container > * {
  max-width: 400px;
  min-width: 200px;
}
page-section .section .scroll-container > * {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  align-items: stretch;
  min-width: min-content;
  margin: auto;
}
page-section .section .scroll-container > * > * {
  width: 100%;
  height: 100%;
  margin: var(--motes-padding);
}
page-section .section .scroll-container > * > :first-child:not(:only-child) {
  margin-left: 0;
}
page-section .section .scroll-container > * > :last-child:not(:only-child) {
  margin-right: 0;
}
page-section .section .scroll-container > * button {
  white-space: nowrap;
}
page-section .section .scroll-container > * > * {
  min-width: 250px;
  height: inherit;
  align-items: flex-start;
}
page-section .section .scroll-container > * > *:only-child {
  margin: auto;
}
page-section .section .scroll-container > * > *:first-child:not(:only-child) {
  margin-left: var(--sub-section-side-padding);
}
page-section .section .scroll-container > * > *:last-child:not(:only-child) {
  margin-right: var(--sub-section-side-padding);
}
page-section .section .blog-post h1, page-section .section .blog-post h2, page-section .section .blog-post h3, page-section .section .blog-post p, page-section .section .blog-post ol, page-section .section .blog-post ul, page-section .section .blog-post .icon, page-section .section .blog-post expandable-paragraphs .title {
  text-align: left;
  color: var(--secondary-color);
}
@media only screen and (max-width: 1024px) {
  page-section .section, page-section .sub-section.large {
    --sub-section-top-padding: 5vh;
    --sub-section-mid-padding: var(--sub-section-top-padding);
    --sub-section-side-padding: max(var(--safe-area-left), var(--sub-section-top-padding));
  }
  page-section .section.stack-tablet {
    --sub-section-top-padding: 4vh;
    --sub-section-height: 50%;
    flex-direction: column;
  }
  page-section .section.stack-tablet.wrap-reverse {
    flex-direction: column-reverse;
  }
  page-section .section.stack-tablet.LARGE, page-section .section.stack-tablet.FULL {
    align-items: inherit;
  }
  page-section .section.stack-tablet .sub-section.sub-nav-padding {
    padding-top: calc(var(--sub-section-top-padding) + 30px);
  }
  page-section .section.stack-tablet .sub-section.center-text > p, page-section .section.stack-tablet .sub-section.dynamic-text > p {
    width: auto;
  }
  page-section .section.stack-tablet .sub-section.dynamic-text {
    text-align: left;
  }
  page-section .section.stack-tablet .sub-section.dynamic-text h1:not(.center), page-section .section.stack-tablet .sub-section.dynamic-text h2:not(.center), page-section .section.stack-tablet .sub-section.dynamic-text p {
    align-self: flex-start;
  }
  page-section .section.stack-tablet .sub-section.dynamic-text h1:not(.center)::after, page-section .section.stack-tablet .sub-section.dynamic-text h2:not(.center)::after {
    margin: 0;
  }
  page-section .section.stack-tablet .sub-section.image img, page-section .section.stack-tablet .sub-section.image picture {
    width: 100%;
  }
  page-section .section .sub-section.center-text > p, page-section .section .sub-section.dynamic-text > p {
    width: 50vw;
  }
  page-section .section .sub-section.laptop-container {
    padding-top: 0;
  }
  page-section .section .sub-section.laptop-container picture {
    display: flex;
    justify-content: center;
    height: 45vh;
  }
  page-section .section .scroll-container .inner-scroll-container > * {
    width: 70vw;
  }
  page-section .section .horizontal-pile-once-list {
    flex-direction: column;
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  page-section .section:not(.stack-tablet) {
    --sub-section-top-padding: 4vh;
    --sub-section-height: 50%;
    flex-direction: column;
  }
  page-section .section:not(.stack-tablet).wrap-reverse {
    flex-direction: column-reverse;
  }
  page-section .section:not(.stack-tablet).LARGE, page-section .section:not(.stack-tablet).FULL {
    align-items: inherit;
  }
  page-section .section:not(.stack-tablet) .sub-section.sub-nav-padding {
    padding-top: calc(var(--sub-section-top-padding) + 30px);
  }
  page-section .section:not(.stack-tablet) .sub-section.center-text > p, page-section .section:not(.stack-tablet) .sub-section.dynamic-text > p {
    width: auto;
  }
  page-section .section:not(.stack-tablet) .sub-section.dynamic-text {
    text-align: left;
  }
  page-section .section:not(.stack-tablet) .sub-section.dynamic-text h1:not(.center), page-section .section:not(.stack-tablet) .sub-section.dynamic-text h2:not(.center), page-section .section:not(.stack-tablet) .sub-section.dynamic-text p {
    align-self: flex-start;
  }
  page-section .section:not(.stack-tablet) .sub-section.dynamic-text h1:not(.center)::after, page-section .section:not(.stack-tablet) .sub-section.dynamic-text h2:not(.center)::after {
    margin: 0;
  }
  page-section .section:not(.stack-tablet) .sub-section.image img, page-section .section:not(.stack-tablet) .sub-section.image picture {
    width: 100%;
  }
  page-section .section .button-filled:not(.short), page-section .section .button-outline:not(.short), page-section .section a {
    width: 100%;
  }
  page-section .section .horizontal-wrap-list {
    flex-wrap: wrap;
    width: auto;
  }
  page-section .section .horizontal-wrap-list > * {
    margin-left: 0;
    margin-right: 0;
    width: 30%;
  }
  page-section .section .laptop-container picture {
    width: 130vw;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/page-section/page-section.component.scss"],"names":[],"mappings":"AAGI;EACI,4DAAA;EACA,8BAAA;EACA,+BAAA;EACA,6BAAA;EAIA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AALR;AAOQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AALZ;AAOY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AALhB;AAUQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AARZ;AAUY;EACI,kBAAA;EACA,eAAA;AARhB;AAUgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AARpB;AAUoB;EACI,iBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AARxB;AAcQ;EACI,wCAAA;AAZZ;AAcY;EACI,YAAA;AAZhB;AAgBQ;EACI,gBAAA;EACA,mBAAA;AAdZ;AAiBQ;EACI,wEAAA;EACA,mBAAA;AAfZ;AAkBQ;EACI,sBAAA;AAhBZ;AAkBY;EACI,iBAAA;AAhBhB;AAoBQ;EACI,sBAAA;AAlBZ;AAqBQ;EACI,kBAAA;EACA,iCAAA;EACA,SAAA;EACA,sBAAA;AAnBZ;AAqBY;EACI,kBAAA;AAnBhB;AAuBQ;EACI,gCAAA;EACA,+BAAA;AArBZ;AAwBQ;EAEI,mBAAA;EACA,mBAAA;AAvBZ;AAyBY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAvBhB;AAyBgB;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;AAvBpB;AA2BY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,sEAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAzBhB;AA2BgB;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;AAzBpB;AA8BQ;EACI,aAAA;EACA,uBAAA;EAEA,gBAAA;AA7BZ;AA+BY;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;AA7BhB;AAgCY;EACI,WAAA;AA9BhB;AAgCgB;EACI,YAAA;AA9BpB;AAgCoB;EACI,YAAA;AA9BxB;AAoCQ;EACI,mBAAA;AAlCZ;AAoCY;EACI,WAAA;EACA,YAAA;AAlChB;AAsCQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AApCZ;AAuCY;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;AArChB;AAyCQ;EACI,uEAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAvCZ;AA0CQ;EACI,mBAAA;EACA,uBAAA;EACA,kBAAA;AAxCZ;AA0CY;EACI,cAAA;AAxChB;AA4CQ;EACI,QAAA;AA1CZ;AA6CQ;EACI,QAAA;AA3CZ;AA8CQ;EACI,QAAA;EACA,qIAAA;AA5CZ;AA+CQ;EACI,QAAA;EACA,sIAAA;AA7CZ;AAgDQ;EACI,mBAAA;EACA,UAAA;EACA,uEAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AA9CZ;AAiDQ;EACI,gBAAA;AA/CZ;AAoDI;EACI,0CAAA;AAlDR;AAoDQ;EACI,2BAAA;AAlDZ;AAuDQ;EACI,4BAAA;AArDZ;AAyDI;EACI,qGAAA;AAvDR;AAyDQ;EACI,2CAAA;AAvDZ;AA0DQ;EACI,6BAAA;AAxDZ;AA2DQ;EACI,4BAAA;AAzDZ;AA4DQ;EACI,wCAAA;EACA,oCAAA;EACA,yBAAA;AA1DZ;AA4DY;EACI,sCAAA;EACA,0CAAA;AA1DhB;AA8DQ;EACI,wCAAA;EACA,6BAAA;EACA,6BAAA;AA5DZ;AA8DY;EACI,wCAAA;AA5DhB;AAoEQ;EACI,eAAA;EACA,kBAAA;AAlEZ;AAoEY;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAlEhB;AA+FQ;EAxBI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;AApEZ;AAsEY;EACI,WAAA;EACA,YAAA;EACA,4BAAA;AApEhB;AAuEY;EACI,cAAA;AArEhB;AAwEY;EACI,eAAA;AAtEhB;AAyEY;EACI,mBAAA;AAvEhB;AA+EQ;EACI,0CAAA;AA7EZ;AA+EY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AA7EhB;AAiFQ;EACI,aAAA;EACA,eAAA;EACA,uBAAA;AA/EZ;AAiFY;EACI,8BAAA;EACA,YAAA;EACA,cAAA;EACA,2BAAA;EACA,gBAAA;AA/EhB;AAmFQ;EACI,aAAA;AAjFZ;AAmFY;EACI,4BAAA;AAjFhB;AAqFQ;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAnFZ;AAqFY;EACI,aAAA;AAnFhB;AAsFY;EACI,uBAAA;AApFhB;AAsFgB;EACI,gBAAA;EACA,gBAAA;AApFpB;AAyFY;EAjFA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;EAgFI,oBAAA;EACA,sBAAA;EACA,YAAA;AApFhB;AAIY;EACI,WAAA;EACA,YAAA;EACA,4BAAA;AAFhB;AAKY;EACI,cAAA;AAHhB;AAMY;EACI,eAAA;AAJhB;AAOY;EACI,mBAAA;AALhB;AAyEgB;EACI,gBAAA;EACA,eAAA;EACA,uBAAA;AAvEpB;AAyEoB;EACI,YAAA;AAvExB;AA0EoB;EACI,4CAAA;AAxExB;AA2EoB;EACI,6CAAA;AAzExB;AAgFY;EACI,gBAAA;EACA,6BAAA;AA9EhB;AAsII;EAEI;IACI,8BAAA;IACA,yDAAA;IACA,sFAAA;EArIV;EA0IU;IA3DJ,8BAAA;IACA,yBAAA;IAGA,sBAAA;EA9EN;EAgFM;IACI,8BAAA;EA9EV;EAiFM;IACI,oBAAA;EA/EV;EAwFU;IACI,wDAAA;EAtFd;EAyFU;IACI,WAAA;EAvFd;EA0FU;IACI,gBAAA;EAxFd;EA0Fc;IACI,sBAAA;EAxFlB;EA2Fc;IACI,SAAA;EAzFlB;EA8Fc;IACI,WAAA;EA5FlB;EAmHc;IACI,WAAA;EAjHlB;EAoHc;IACI,cAAA;EAlHlB;EAoHkB;IACI,aAAA;IACA,uBAAA;IACA,YAAA;EAlHtB;EAuHU;IACI,WAAA;EArHd;EAwHU;IACI,sBAAA;IACA,WAAA;EAtHd;AACF;AA2HI;EAIQ;IAhGJ,8BAAA;IACA,yBAAA;IAGA,sBAAA;EA7BN;EA+BM;IACI,8BAAA;EA7BV;EAgCM;IACI,oBAAA;EA9BV;EAuCU;IACI,wDAAA;EArCd;EAwCU;IACI,WAAA;EAtCd;EAyCU;IACI,gBAAA;EAvCd;EAyCc;IACI,sBAAA;EAvClB;EA0Cc;IACI,SAAA;EAxClB;EA6Cc;IACI,WAAA;EA3ClB;EAqGU;IACI,WAAA;EAnGd;EAuGU;IACI,eAAA;IACA,WAAA;EArGd;EAuGc;IACI,cAAA;IACA,eAAA;IACA,UAAA;EArGlB;EAyGU;IACI,YAAA;EAvGd;AACF","sourcesContent":["page-section {\n    \n    // Section and sub-section layout\n    .section {\n        --sub-section-side-padding: max(var(--safe-area-left), 10vw);\n        --sub-section-mid-padding: 5vw;\n        --sub-section-top-padding: 10vh;\n        --sub-section-height: inherit;\n        // --sub-section-width: 50%;\n        // --sub-section-padded-width: calc(var(--sub-section-width) - (var(--sub-section-side-padding) + var(--sub-section-mid-padding)));\n        \n        display: flex;\n        justify-content: center;\n        align-items: stretch;\n        overflow: hidden;\n        position: relative;\n\n        picture.bg {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            overflow: hidden;\n            position: absolute;\n            height: 100%;\n            width: 100%;\n            \n            img {\n                flex-shrink: 0;\n                min-width: 100%;\n                min-height: 100%;\n            }\n            \n        }\n\n        light-image.bg {\n            position: absolute;\n            height: 100%;\n            width: 100%;\n\n            .image-container {\n                padding-top: unset;\n                height: inherit;\n\n                picture {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    height: inherit;\n\n                    img {\n                        position: initial;\n                        top: initial;\n                        left: initial;\n                        width: initial;\n                        box-sizing: initial;\n                        min-height: 100%;\n                    }\n                }\n            }\n        }\n\n        .bg.dark, .bg-image .image {\n            background-color: var(--secondary-color);\n            \n            img {\n                opacity: 0.2;\n            }\n        }\n\n        &.LARGE {\n            min-height: 75vh;\n            align-items: center;\n        }\n\n        &.FULL {\n            min-height: calc(100vh - var(--header-height) - var(--safe-area-bottom));\n            align-items: center;\n        }\n\n        &.parent {\n            flex-direction: column;\n\n            > .sub-section:first-child {\n                padding-bottom: 0;\n            }\n        }\n\n        &:has(.sub-section:only-child) {\n            flex-direction: column;\n        }\n\n        .sub-section {\n            position: relative;\n            height: var(--sub-section-height);\n            flex: 50%;\n            box-sizing: border-box;\n            \n            img {\n                align-self: center;\n            }\n        }\n\n        .sub-section.large {\n            --sub-section-side-padding: 12vw;\n            --sub-section-mid-padding: 12vw;\n        }\n\n        .sub-section.bg-image {\n            // width: var(--sub-section-width);\n            min-height: inherit;\n            align-self: stretch;\n\n            picture.image {\n                position: absolute;\n                height: 100%;\n                width: 100%;\n                overflow: hidden;\n                display: flex;\n                justify-content: center;\n\n                img {\n                    align-self: auto;\n                    object-fit: cover;\n                    width: 100%;\n                }\n            }\n\n            .image-overlay {\n                position: absolute;\n                height: 100%;\n                width: 100%;\n                box-sizing: border-box;\n                padding: var(--sub-section-top-padding) var(--sub-section-mid-padding);\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n\n                img {\n                    width: 100%;\n                    max-height: 40vh;\n                    object-fit: contain;\n                }\n            }\n        }\n\n        .sub-section.image, .sub-section.floating-element {\n            display: flex;\n            justify-content: center;\n            // width: var(--sub-section-width);\n            overflow: hidden;\n\n            img {\n                object-fit: cover;\n                height: 100%;\n                align-self: center;\n            }\n\n            motes-media {\n                width: 100%;\n\n                #media-container {\n                    height: 100%;\n\n                    .image-container {\n                        height: 100%;\n                    }\n                }\n            }\n        }\n\n        .sub-section.floating-element {\n            align-items: center;\n\n            img, video {\n                width: 100%;\n                height: auto;\n            }\n        }\n\n        .sub-section.padded-left, .sub-section.padded-right {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;  \n            // width: var(--sub-section-padded-width);\n\n            img {\n                object-fit: contain;\n                max-height: 100%;\n                max-width: 100%;\n            }\n        }\n\n        .sub-section.padded-center {\n            padding: var(--sub-section-top-padding) var(--sub-section-side-padding);\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n        }\n\n        .sub-section.center-text, .sub-section.dynamic-text {\n            align-items: center;\n            justify-content: center;\n            text-align: center;\n\n            h1::after, h2::after {\n                margin: 0 auto;\n            }\n        }\n\n        .sub-section.order-one {\n            order: 0;\n        }\n\n        .sub-section.order-two {\n            order: 1;\n        }\n\n        .sub-section.padded-left {\n            order: 0;\n            padding: var(--sub-section-top-padding) var(--sub-section-mid-padding) var(--sub-section-top-padding) var(--sub-section-side-padding);\n        }\n\n        .sub-section.padded-right {\n            order: 1;\n            padding: var(--sub-section-top-padding) var(--sub-section-side-padding) var(--sub-section-top-padding) var(--sub-section-side-padding);\n        }\n\n        .sub-section.image-bg {\n            min-height: inherit;\n            padding: 0;\n            padding: var(--sub-section-top-padding) var(--sub-section-side-padding);\n            background-position: center;\n            background-repeat: no-repeat;\n            background-size: cover;\n        }\n\n        p, expandable-paragraphs .title {\n            max-width: 800px;\n        }\n    }\n\n    // Section colors\n    .section.BLACK {\n        background-color: var(--motes-light-black);\n        \n        a > p, p a {\n            color: var(--primary-color);\n        }\n    } \n\n    .section.WHITE {\n        a > p, p a {\n            color: var(--tertiary-color);\n        }\n    }\n\n    .section.YELLOW {\n        background: transparent linear-gradient(180deg, #FFDC8B 0%, #EFBE61 100%) 0% 0% no-repeat padding-box;\n\n        h1::after, h2::after {\n            border-bottom-color: var(--secondary-color);\n        }\n        \n        h1, h2, h3, p, ol, ul, .icon, a:hover {\n            color: var(--secondary-color);\n        }\n\n        a > p, p a {\n            color: var(--tertiary-color);\n        }\n\n        .button-filled {\n            background-color: var(--secondary-color);\n            border-color: var(--secondary-color);\n            color: var(--motes-white);\n\n            &:hover, &:active {\n                border-color: var(--motes-darker-gray);\n                background-color: var(--motes-darker-gray);\n            }\n        }\n\n        .button-outline {\n            border: solid 2px var(--secondary-color);\n            background-color: transparent;\n            color: var(--secondary-color);\n\n            &:hover, &:active {\n                background-color: rgba(34, 34, 34, 0.15);\n            }\n        }\n    } \n\n    // Special section content \n    .section {\n\n        .sub-section.trailer-container {\n            cursor: pointer;\n            position: relative;\n\n            .play-overlay {\n                position: absolute;\n                display: flex;\n                width: 100%;\n                height: 100%;\n                justify-content: center;\n                align-items: center;\n                color: white;\n                font-size: 70px;\n            }\n        }\n\n        @mixin horizontal-list {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            width: 100%;\n\n            > * {\n                width: 100%;\n                height: 100%;\n                margin: var(--motes-padding);\n            }\n\n            > :first-child:not(:only-child) {\n                margin-left: 0;\n            }\n\n            > :last-child:not(:only-child) {\n                margin-right: 0;\n            }\n\n            button {\n                white-space: nowrap;\n            }\n        }\n\n        .horizontal-wrap-list {\n            @include horizontal-list;\n        }\n\n        .horizontal-wrap-list {\n            margin-top: var(--sub-section-mid-padding);\n    \n            * > img {\n                width: 100%;\n                height: 100%;\n                max-height: 150px;\n                object-fit: contain;\n            }\n        }\n\n        .horizontal-pile-list {\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: center;\n\n            > * {\n                margin: 0 var(--motes-padding);\n                flex-grow: 1;\n                flex-shrink: 1;\n                flex-basis: min(40%, 400px);\n                min-width: 280px;\n            }\n        }\n\n        .horizontal-pile-once-list {\n            display: flex;\n\n            > * {\n                margin: var(--motes-padding);\n            }\n        }\n\n        .scroll-container {\n            overflow-x: scroll;\n            overflow-y: hidden;\n            width: 100vw;\n            align-self: center;\n\n            &::-webkit-scrollbar {\n                display: none;\n            }\n\n            &.short .inner-scroll-container {\n                justify-content: center;\n\n                > * {\n                    max-width: 400px;\n                    min-width: 200px;\n                }\n            }\n\n            // scroll items container\n            > * {\n                @include horizontal-list;\n                align-items: stretch;\n                min-width: min-content;\n                margin: auto;\n                \n                // item\n                > * {\n                    min-width: 250px;\n                    height: inherit;\n                    align-items: flex-start;\n\n                    &:only-child {\n                        margin: auto;\n                    }\n                \n                    &:first-child:not(:only-child) {\n                        margin-left: var(--sub-section-side-padding);\n                    }\n    \n                    &:last-child:not(:only-child) {\n                        margin-right: var(--sub-section-side-padding);\n                    }\n                }\n            }\n        }\n\n        .blog-post {\n            h1, h2, h3, p, ol, ul, .icon, expandable-paragraphs .title  {\n                text-align: left;\n                color: var(--secondary-color);\n            }\n        }\n    }\n\n    // Styles for stacking sub-sections\n    @mixin section-stack {\n        --sub-section-top-padding: 4vh;\n        --sub-section-height: 50%;\n        // --sub-section-width: 100%;\n\n        flex-direction: column;\n\n        &.wrap-reverse {\n            flex-direction: column-reverse;\n        }\n\n        &.LARGE, &.FULL {\n            align-items: inherit;\n        }\n\n        // &.FULL {\n        //     min-height: calc(100vh - var(--header-height) - var(--safe-area-bottom) + 1px);\n        // }\n\n        .sub-section {\n\n            &.sub-nav-padding {\n                padding-top: calc(var(--sub-section-top-padding) + 30px);\n            }\n\n            &.center-text > p, &.dynamic-text > p {\n                width: auto;\n            }\n\n            &.dynamic-text {\n                text-align: left;\n                    \n                h1:not(.center), h2:not(.center), p {\n                    align-self: flex-start;\n                }\n    \n                h1:not(.center)::after, h2:not(.center)::after {\n                    margin: 0;\n                }\n            }\n            \n            &.image {\n                img, picture {\n                    width: 100%;\n                }\n            } \n        }\n    }\n\n    // Tablet view\n    @media only screen and (max-width: 1024px) {\n\n        .section, .sub-section.large {\n            --sub-section-top-padding: 5vh;\n            --sub-section-mid-padding: var(--sub-section-top-padding);\n            --sub-section-side-padding: max(var(--safe-area-left), var(--sub-section-top-padding));\n        }\n\n        .section {\n\n            &.stack-tablet {\n                @include section-stack;\n            }\n\n            .sub-section {\n    \n                &.center-text > p, &.dynamic-text > p {\n                    width: 50vw;\n                }\n\n                &.laptop-container {\n                    padding-top: 0;\n    \n                    picture {\n                        display: flex;\n                        justify-content: center;\n                        height: 45vh;\n                    }\n                }\n            }\n\n            .scroll-container .inner-scroll-container > * {\n                width: 70vw;\n            }\n\n            .horizontal-pile-once-list {\n                flex-direction: column;\n                width: 100%;\n            }\n        }\n    }\n\n    // Mobile view\n    @media only screen and (max-width: 600px) {\n\n        .section {\n\n            &:not(.stack-tablet) {\n                @include section-stack;\n            }\n\n            .button-filled:not(.short), .button-outline:not(.short), a {\n                width: 100%;\n            }\n\n            // horizontal full-width list -> table with 3 items per row\n            .horizontal-wrap-list {\n                flex-wrap: wrap;\n                width: auto;\n\n                > * {\n                    margin-left: 0;\n                    margin-right: 0;\n                    width: 30%;\n                }\n            }\n\n            .laptop-container picture {\n                width: 130vw;\n            }\n        }\n    }    \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
